import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search, Calculator, FileText } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-slate-200">404</h1>
          <h2 className="text-3xl font-bold text-slate-900 -mt-8">Page Not Found</h2>
        </div>
        
        <p className="text-xl text-slate-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Home className="w-5 h-5 mr-2" />
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-6 py-3 bg-slate-200 text-slate-700 font-semibold rounded-lg hover:bg-slate-300 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Go Back
          </button>
        </div>

        <div className="border-t border-slate-200 pt-8">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Popular Pages</h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Link
              to="/tools"
              className="flex items-center p-4 bg-white rounded-lg shadow hover:shadow-md transition-shadow"
            >
              <Calculator className="w-6 h-6 text-blue-600 mr-3" />
              <span className="font-medium text-slate-700">Calculation Tools</span>
            </Link>
            <Link
              to="/quote"
              className="flex items-center p-4 bg-white rounded-lg shadow hover:shadow-md transition-shadow"
            >
              <FileText className="w-6 h-6 text-green-600 mr-3" />
              <span className="font-medium text-slate-700">Request Quote</span>
            </Link>
            <Link
              to="/pricing"
              className="flex items-center p-4 bg-white rounded-lg shadow hover:shadow-md transition-shadow"
            >
              <Search className="w-6 h-6 text-purple-600 mr-3" />
              <span className="font-medium text-slate-700">Pricing</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
